'use client';

import { IcArrowRight, Typography } from '@musinsa/mds';
import Link from 'next/link';
import type { MouseEvent } from 'react';
import { useNavigate } from '../../common/hooks/useNavigate';

interface CampaignDiscountItemProps {
  href: string;
  text: string;
  onClick?: () => void;
  className?: string;
}

export const CampaignDiscountItem = ({
  href,
  text,
  onClick,
  className,
}: CampaignDiscountItemProps) => {
  const { navigate } = useNavigate();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onClick?.();
    navigate(href);
  };

  return (
    <Link href={href} onClick={handleClick} className={className}>
      <div className="flex items-center gap-12 py-3">
        <div className="flex-1">
          <Typography size="14" weight="medium">
            {text}
          </Typography>
        </div>

        <div className="flex-shrink-0">
          <IcArrowRight width={16} height={16} strokeColor="gray-500" />
        </div>
      </div>
    </Link>
  );
};
